import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import { athenaURL } from "../../env";
import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import * as virActions from "src/actions/virActions";
import * as appActions from "../../actions/appActions";
import convertPhoneNumber from "src/utils/convertPhoneNumber";
import { RoundedButton, Button } from "@packages/ui";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import VirPhoneInput from "src/components/VirPhoneInput/VirPhoneInput";
import VirComfirmDialog from "src/components/VirConfirmDialog/VirConfirmDialog";
import brandColors from "@packages/ui/theme/colors";

import { set } from "lodash";

const DigitalVIRSubmissionPage = () => {
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState(
    useSelector((state) => state.vir.athenaVirAuth?.data?.phoneNumber) || ""
  );
  const selectedVirid = useSelector((state) => state.vir?.athenaSelectedId?.selectedId);
  const virBE = useSelector((state) => state.vir.virPrepareBE);
  const source = useSelector((state) => state.vir.athenaSource?.source);
  const reportType = useSelector((state) => state.vir.athenaReportType?.reportType) || "";

  const virId = useSelector((state) => state.vir.athenaSelectedId?.selectedId);
  const virType = useSelector((state) => state.vir.athenaSelectedType?.selectedType);
  const authorization = useSelector((state) => state.vir.athenaAuth.authorization);
  const raNumber = useSelector((state) => state.vir.athenaVirAuth?.data?.raNumber) || "";
  const nonrevNumber = useSelector((state) => state.vir.athenaVirAuth?.data?.nonrevNumber) || "";
  const createdBy = useSelector((state) => state.vir.athenaVirDetail?.data?.CreatedBy) || "";
  const smsSent = useSelector((state) => state.vir.athenaVirDetail?.data?.SmsIsSent) || "";
  const raStatus = useSelector((state) => state.vir.athenaVirAuth?.data?.Status) || "";
  const returnDate = useSelector((state) => state.vir.athenaVirAuth?.data?.returnDate) || "";
  const [sendFlag, setSendFlag] = useState(false);
  const [sending, setSending] = useState(false);
  const [openSmsDialog, setOpenSmsDialog] = useState(false);
  const classes = useStyles();
  const brand = getBrandFromUrl().toLowerCase();
  const userName = useSelector((state) => state.vir.athenaVirAuth?.data?.customerName);
  const [smsDialogContent, setSmsDialogContent] = useState("");
  useEffect(() => {
    dispatch(
      virActions.detailPatchVir({
        virId: selectedVirid,
        virStatus: "SubmissionPage",
      })
    );
  }, []);

  useEffect(() => {
    if (openSmsDialog) {
      if (smsSent) {
        setSmsDialogContent(
          "The customer has already been sent this VIR form. Do you want to resend?"
        );
        return;
      } else if (createdBy !== "" && createdBy === "customer") {
        setSmsDialogContent(
          "This VIR was originally submitted by the customer. Do you want to send them the VIR form?"
        );
        return;
      } else if (raStatus !== "Open") {
        setSmsDialogContent(
          "The status of this RA is closed. Do you want to send the customer this VIR form?"
        );
        return;
      } else if (raStatus === "Open" && returnDate) {
        const returnDateObj = new Date(returnDate);
        const now = new Date();
        const diffDays = (now - returnDateObj) / (1000 * 60 * 60 * 24);
        if (diffDays > 14) {
          setSmsDialogContent(
            "The RA is open but the return date was more than 14 days ago. Do you want to send the customer this VIR form?"
          );
          return;
        }
      } else {
        setSmsDialogContent("Do you want to send the customer this VIR form?");
        return;
      }
    }
  }, [openSmsDialog]);

  const goToMJP = () => {
    if (raNumber) {
      window.location.href = `https://myjourney.hertz.com.au/login?raNumber=${raNumber}`;
    } else {
      window.location.href = "https://myjourney.hertz.com.au/login";
    }
  };

  const sendSms = async () => {
    // const url = "https://portal.dev.hertz.asiapac.io"; // for dev
    setSending(true);
    setSendFlag(true);

    const url = "https://portal.staging.hertz.asiapac.io"; // for staging
    // const url = "http://localhost:8080";

    const link = `${url}/vehicleincidents/landing-page?source=sms&rego=${
      virBE.Registration
    }&vir=${virId}&virType=${virType}&brand=${brand}${
      raNumber !== "" ? `&raNumber=${raNumber}` : ""
    }${nonrevNumber !== "" ? `&nonrevNumber=${nonrevNumber}` : ""}`;
    const param = {
      url: link,
      ttl: 60 * 60 * 72,
      mobile: convertPhoneNumber(phoneNumber),
      virId: virId,
      brand: brand,
      message: `Hi ${
        userName.split(" ")[0]
      }, a vehicle incident has been identified on your rental. Please click the link to view the photos and complete the form with any additional information or upload photos regarding the incident.`,
    };
    const res = await fetch(`${athenaURL}/vir/sendSMS`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authorization}`,
      },
      body: JSON.stringify(param),
    });

    setSending(false);
    if (res.ok) {
      dispatch(
        appActions.createToast({
          type: "success",
          message: "Send SMS success.",
        })
      );
    } else {
      dispatch(
        appActions.createToast({
          type: "error",
          message: "Send SMS failed, please contect our staff.",
        })
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          textAlign: "center",
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
          fontWeight: "500",
        }}
      >
        <h1 className={classes.heading}>Vehicle incident report submitted</h1>

        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          {/* <CheckCircleOutlineIcon style={{ fontSize: "64px" }} color="primary" /> */}
          <img
            alt="check_mark"
            src={`/static/images/ticks/${brand === "firefly" ? "ace" : brand}_Tick.png`}
            style={{ width: "150px", height: "150px", margin: "20px" }}
          />
          <Typography
            style={{ fontFamily: "Ride", fontSize: "20px", fontWeight: "bold" }}
            align="center"
          >
            You may now exit this screen
          </Typography>
        </Box>

        <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] }} />

        {source !== "app" && reportType !== "unReported" && (
          <>
            <Typography className={classes.descripe} align="center" paragraph>
              To view your vehicle incident report details and photos, click the link and log into
              My Journey Portal.
            </Typography>
            <RoundedButton variant="contained" onClick={goToMJP} fullWidth>
              My Journey Portal
            </RoundedButton>
          </>
        )}
        {source === "app" && reportType !== "unReported" && virType === "panel" && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              textAlign: "center",
              fontFamily: "Ride",
              color: "#333",
              margin: "0 auto",
              justifyContent: "center",
              justifyItems: "center",
            }}
          >
            <Typography
              style={{
                fontFamily: "Ride",
                fontSize: "20px",
                paddingBottom: "15px",
                fontWeight: "600",
              }}
              align="center"
            >
              If you require additional details from the customer regarding the damage or any 3rd
              parties involved, please select{" "}
              <u>
                <strong>&apos;Send SMS&apos;</strong>
              </u>
              .
            </Typography>
            <Typography
              style={{
                fontFamily: "Ride",
                fontSize: "15px",
                paddingBottom: "30px",
                paddingTop: "15px",
                color: "grey",
                fontWeight: "600",
              }}
              align="center"
            >
              Please note: the customer will be able to view the information you&apos;ve provided,
              including any photos.
            </Typography>

            <VirPhoneInput
              phoneNumber={phoneNumber}
              onChange={(value) => {
                setPhoneNumber(value);
              }}
            />
            <Typography
              style={{
                fontFamily: "Ride",
                fontSize: "13px",
              }}
              align="center"
            >
              Update customer mobile as required
            </Typography>
          </Box>
        )}
        <Box display="flex" flexDirection="column" alignItems="center" my={3}>
          {source === "app" && reportType !== "unReported" && virType === "panel" && (
            <>
              <Button
                variant="contained"
                disabled={sendFlag}
                onClick={() => setOpenSmsDialog(true)}
                size="large"
                style={{
                  width: "350px",
                  fontFamily: "Ride",
                  marginTop: "30px",
                  borderRadius: "30px",
                  fontWeight: "bold",
                }}
              >
                {sending ? <CircularProgress /> : "Send SMS"}
              </Button>
            </>
          )}
        </Box>
        <VirComfirmDialog
          open={openSmsDialog}
          handleClose={() => setOpenSmsDialog(false)}
          content={smsDialogContent}
          title={"Send SMS Comfirmation"}
          execute={() => {
            sendSms();
            setOpenSmsDialog(false);
          }}
        />
      </Box>
    </>
  );
};

export default DigitalVIRSubmissionPage;
